import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.join";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from "element-ui";
import addenvironment from "./components/addenvironment";
import { gmToolNew } from "@/mixins/index";
import { yjenvlist, delyjenv } from "@/api/gmToolNew/gmToolNew";
export default {
  name: "environment",
  mixins: [gmToolNew],
  components: {
    addenvironment: addenvironment
  },
  data: function data() {
    return {
      tableData: [],
      total: 0,
      page: 1,
      loading: false,
      sels: [],
      selsString: '',
      paramsData: {}
    };
  },
  created: function created() {
    this.getData(1);
  },
  methods: {
    handleSource: function handleSource(row) {
      this.$refs.addenvironment.init(row);
    },
    sizeChange: function sizeChange(e) {
      this.paramsData.page_size = e;
      this.getData(1);
    },
    getData: function getData(e) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                _this.paramsData.page = e;
                yjenvlist(_this.paramsData).then(function (res) {
                  if (res.status == 200) {
                    var list = [];
                    res.data.forEach(function (i) {
                      list.push({
                        env_name: i.name,
                        env_flag: i.flag,
                        env_gm_url: i.gm_url,
                        env_manage_url: i.manage_url,
                        envID: i.id,
                        id: i.id,
                        game_ids: i.game_id,
                        game_name: i.game_name && i.game_name.length ? i.game_name.join(",") : ""
                      });
                    });
                    _this.tableData = list;
                  }
                }).finally(function () {
                  _this.loading = false;
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      var _this2 = this;

      this.sels = [];
      val.forEach(function (e) {
        _this2.sels.push(e.id);
      });
      this.selsString = this.sels.toString();
    },
    handleDelete: function handleDelete(id) {
      var _this3 = this;

      this.$confirm(this.$t('confirmDeleteData'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                delyjenv({
                  ids: id
                }).then(function (res) {
                  if (res.status == 200) {
                    _this3.$message.success(_this3.$t('deleteSuccess'));

                    _this3.getData(_this3.paramsData.page);
                  }
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    }
  }
};